<template>
    <div>
        <el-dialog v-bind:title="currentSkill.name" customClass="dialogWidth-1000" width="90%"  :visible.sync="skilldialog" @close="closeDialog" :close-on-click-modal="false" :before-close="saveAlert" :close-on-press-escape="false">
            <!--进度条-->
            <el-row class="pb-20">
                <el-col :span="24" class="text-center p-10 bg-lightgarg">
                    <div class="el-col-20 el-col-offset-2">
                                <span v-for="(page, pageIndex) in currentSkill.pageList" :key="page.id">
                                    <el-button :disabled="isDialogLoading" type="text" v-bind:style="page.page == currentPage ?'text-decoration:underline; color:#13CE66':''" @click="showNextPage(currentSkill, page.page, page.id)"><b>{{page.page}}</b></el-button>&nbsp;&nbsp;<i v-if="pageIndex != (currentSkill.pageList.length -1)" class="el-icon-caret-right"></i>&nbsp;&nbsp;
                                </span>

                    </div>

                </el-col>
                <div class="owner">
                    <el-tag color="white" type="success">owner: <b>{{displayName}}</b></el-tag>
                </div>
            </el-row>
            <el-main v-if="role == 'teacher' && pageLock" class="mb-20" style="border:2px solid #dddddd; text-align: center">
                <span>Locked: </span>
                <el-switch
                        v-model="lock"
                        active-color="#13ce66"
                        inactive-color="#dddddd"
                        @change="switchLock(lock)"
                >
                </el-switch>
            </el-main>
            <el-form v-loading="isDialogLoading">
                <el-card class="mb-20" v-for="(questionGroup, index) in questions" :key="index">
                    <template v-for="question in questionGroup">
                        <el-row>
                            <el-col>
                                <el-tooltip class="mb-2 mt-5" effect="dark" placement="bottom" :disabled="question.guidance == null">
                                    <div style="max-width: 1000px;" slot="content" v-html="question.guidance" ></div>
                                    <div class="inlineBlock">
                                        <h4 :style="question.highlighted?'background:yellow;':''" :id="'question'+ question.id">
                                            <el-tag type="info" size="mini">{{question.sequence}}</el-tag>
                                            {{question.title}}
                                        </h4>
                                    </div>
                                </el-tooltip>
<!--                                <el-tag v-if="role == 'teacher'&&question.canBeConfirm===true&&question.lastUpdated!==null" type="gray" color="white">Last modified: {{question.lastUpdated}}</el-tag>-->
                                <el-button type="primary" size="mini" v-if="(role == 'teacher' || role == 'ta') && !question.confirmed" :disabled="!question.canBeConfirm" @click="confirm(question)" :loading="question.isConfirmLoading">confirm</el-button>
                                <el-tag v-if="role == 'student' && question.confirmed && !question.config.forTeacher" type="primary" color="white" >confirmed</el-tag>
                                <el-button type="danger" size="mini" v-if="(role == 'teacher' || role == 'ta') && question.confirmed" :loading="question.isDisapproveLoading" @click="disapprove(question)" >disapprove</el-button>
                            </el-col>
                        </el-row>
                        <template v-if="question.config.type == 'table'">
                            <el-row>
                                <el-col class="mt-5">
                                    <el-table :class="`drag${index}`" :data="question.config.list" row-key="id">
                                        <el-table-column v-for="(cell, index) in question.config.title" v-bind:label="cell" :width="question.config.width=== undefined ?'': question.config.width[index]" :key="index">
                                            <template slot-scope="scope">
                                                <el-date-picker
                                                        v-if="scope.row.list && scope.row.list[index].type == 'tableDate'"
                                                        format="yyyy-MM-dd"
                                                        :picker-options="datepickerOptions.option1"
                                                        type="date" class="mt-5 mb-5"
                                                        :disabled="lock || (role != 'teacher' && role !== 'ta') && question.config.forTeacher"
                                                        :title="disabledTips"
                                                        v-model="scope.row.list[index].answer"
                                                        placeholder="Select date"
                                                        @change="isDirty=true;"
                                                        style="width: 100%">
                                                </el-date-picker>
                                                <el-input
                                                        v-if="scope.row.list && scope.row.list[index].type == 'tableInput'"
                                                        type="textarea"
                                                        :disabled="lock || (role != 'teacher' && role !== 'ta') && question.config.forTeacher"
                                                        :title="disabledTips"
                                                        :rows="scope.row.list[index].rows"
                                                        class="mt-5 mb-5"
                                                        v-model="scope.row.list[index].answer"
                                                        @change="checkQuestionInput">
                                                </el-input>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </el-col>
                            </el-row>
                        </template>
                        <template v-for="(row, index) in question.config.list">
                            <el-row :gutter="20">
                                <template v-for="(col,index) in row">
                                    <el-col :span="col.spans*24" v-if="col.type == 'input'">
                                        <p class="gary mb-5">{{col.description}}</p>
                                        <el-form-item class="mb-none" prop="answer"  ref="col" >
                                            <el-input type="textarea" :rows="col.rows" v-model="col.answer"
                                                      :title="disabledTips"
                                                      :placeholder="(role != 'teacher' && role !== 'ta') && question.config.forTeacher?'To be edited by teacher':''"
                                                      :disabled="lock || (role != 'teacher' && role !== 'ta') && question.config.forTeacher" @change="checkQuestionInput"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="col.spans*24" v-if="col.type == 'text'" :disabled="true">
                                        <p class="gary mb-5">{{col.description}}</p>
                                        <el-form-item class="mb-none"  prop="answer">
                                            <el-input  type="text" :rows="col.rows" v-model="col.answer"
                                                      :title="disabledTips"
                                                      :placeholder="(role != 'teacher' && role !== 'ta') && question.config.forTeacher?'To be edited by teacher':''"
                                                      :disabled="lock || (role != 'teacher' && role !== 'ta') && question.config.forTeacher" @change="checkQuestionInput"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="col.spans*24" v-if="col.type=='datetime'">
                                        <p class="gary  mt-5">{{col.dateDescription}}</p>
                                        <el-date-picker
                                                format="yyyy-MM-dd"
                                                :picker-options="datepickerOptions.option1"
                                                type="date" class="mt-5"
                                                v-model="col.date"
                                                :title="disabledTips"
                                                :placeholder="(role != 'teacher' && role !== 'ta') && question.config.forTeacher?'To be edited by teacher':'Select date'"
                                                :disabled="lock || (role != 'teacher' && role !== 'ta') && question.config.forTeacher"
                                                @change="isDirty=true;"
                                                style="width: 100%">
                                        </el-date-picker>
                                        <p class="gary mt-5">{{col.timeDescription}}</p>
                                        <el-time-picker
                                                format="HH:mm:ss"
                                                v-model="col.time" class="mt-5"
                                                :title="disabledTips"
                                                :placeholder="(role != 'teacher' && role !== 'ta') && question.config.forTeacher?'To be edited by teacher':'Select time'"
                                                :disabled="lock || (role != 'teacher' && role !== 'ta') && question.config.forTeacher"
                                                @change="isDirty=true;"
                                                style="width: 100%">
                                        </el-time-picker>
                                    </el-col>
                                    <el-col :span="col.spans*24" v-if="col.type=='date'">
                                        <p class="gary ">{{col.dateDescription}}</p>
                                        <el-date-picker
                                                format="yyyy-MM-dd"
                                                v-model="col.answer"
                                                :picker-options="datepickerOptions.option1"
                                                type="date" class="mt-5"
                                                :title="disabledTips"
                                                :placeholder="(role != 'teacher' && role !== 'ta') && question.config.forTeacher?'To be edited by teacher':'Select date'"
                                                :disabled="lock || (role != 'teacher' && role !== 'ta') && question.config.forTeacher"
                                                @change="isDirty=true;"
                                                style="width: 100%">
                                        </el-date-picker>
                                    </el-col>
                                    <el-col :span="col.spans*24" v-if="col.type=='checkbox'">
                                      <span>
                                          <p class="gary ">{{col.description}}</p>
                                          <el-checkbox-group v-model="col.answer" @change="isDirty=true;" style="vertical-align:middle;">
                                                <template v-if="col.vertical">
                                                    <p v-for="(cb, index) in col.list" :key="index">
                                                        <el-checkbox
                                                         :key="index"
                                                         :label="cb"
                                                         :title="disabledTips"
                                                         :disabled="lock || (role != 'teacher' && role !== 'ta') && question.config.forTeacher"
                                                        >
                                                            <span style="white-space: normal;word-wrap:break-word;vertical-align:top;display: inline-block;">{{cb}}</span>
                                                        </el-checkbox>
                                                    </p>
                                                </template>
                                                <template v-else>
                                                    <el-checkbox v-for="(cb, index) in col.list"
                                                                 :key="index" v-bind:label="cb"
                                                                 :title="disabledTips"
                                                                 :disabled="lock || (role != 'teacher' && role !== 'ta') && question.config.forTeacher"
                                                    ></el-checkbox>
                                                </template>

                                       </el-checkbox-group>
                                      </span>
                                    </el-col>
                                    <el-col :span="Math.floor(col.spans*24)" v-if="col.type=='radio'">
                                         <span>
                                          <p class="gary ">{{col.description}}</p>
                                            <template v-if="col.vertical">
                                                <p v-for="(lb, index) in col.list" :key="index">
                                                    <el-radio :disabled="lock || (role != 'teacher' && role !== 'ta') && question.config.forTeacher" class="radio mb-5" v-model="col.answer" :label="lb" @change="isDirty=true;"></el-radio>
                                                </p>
                                            </template>
                                            <template v-else>
                                                <el-radio class="radio mb-5 mt-5" v-for="(lb, index) in col.list" :key="index" v-model="col.answer" :label="lb"
                                                          @change="isDirty=true;"
                                                          :disabled="lock || (role != 'teacher' && role !== 'ta') && question.config.forTeacher"></el-radio>
                                            </template>
                                         </span>
                                    </el-col>
                                </template>
                            </el-row>
                        </template>
                        <el-row >

                            <el-col class=" mt-5" v-if="question.config.more" :span=5 >
                                <el-button-group>
                                    <el-button class="p-5" type="danger" :disabled="lock" v-on:click="more(question.config.list)" size="mini" icon="el-icon-plus"></el-button>
                                    <el-button class="p-5" type="success" :disabled="lock" v-on:click="less(question.config.list)" size="mini" icon="el-icon-minus"></el-button>
                                </el-button-group>
                            </el-col>
                        </el-row>
                        <el-row v-if="role=='ta' || role == 'student'">
                            <el-col :span="24" class="p-10 bg-lightgarg mt-5" v-if="question.commentList && question.commentList.length != 0">
                                <el-button v-if="question.showCommentCount ==3 && question.commentList.length > 3" v-on:click="question.showCommentCount = question.commentList.length" type="text">View {{question.commentList.length-showCommentCount}} more comments</el-button>
                                <el-button v-if="question.showCommentCount !=3 && question.commentList.length > 3" v-on:click="question.showCommentCount = 3" type="text">Hide more</el-button>
                                <div>
                                    <div v-for="(comment, commentIndex) in question.commentList" :key="commentIndex" v-show="commentIndex > question.commentList.length-question.showCommentCount-1">
                                        <div :style="comment.highlighted?'background:yellow;':''" class="dark  mt-5 commentContent" :id="'comment'+comment.id">
                                            <span class="success"><b>{{comment.fromName}}</b></span> : {{comment.content}}</div>
                                        <div class="gary mb-2">{{comment.time}}<el-button type="text" size="small" class="ml-5" @click="cancelComment(comment, question.commentList)" v-if="comment.userId == userId">remove</el-button></div>
                                    </div>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row class="mb-10 mt-5" v-if="role=='ta' || role == 'student'">
                            <el-col :span="1">
                                <el-button type="success" v-if="!question.config.forTeacher" size="mini" v-on:click="question.show = !question.show">{{question.show?'&nbsp;&nbsp;&nbsp;&nbsp;Hide&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;':'Comment'}}</el-button>
                            </el-col>
                        </el-row>
                        <el-row class="mb-10" v-show="question.show" v-loading="question.isSavingComment">
                            <el-col :span="20">
                                <el-input class="post-textarea" @keyup.native="pressAction(question,question.commentList,$event)" type="textarea" placeholder="Press Ctrl + Enter to post" :rows="3" autofocus resize="none" v-model="question.content" @change="checkEmoji"></el-input>
                            </el-col>
                            <el-col :span="3">
                                <el-button type="success" :disabled="!question.content" v-on:click="saveComment(question,question.commentList)" size="small" class="comment-submit pt-30 pb-30 pl-30 pr-30">Post</el-button>
                            </el-col>
                        </el-row>
                    </template>
                </el-card>
            </el-form>
            <span slot="footer"></span>
        </el-dialog>
        <div class="fixedFooter" v-show="this.skilldialog && !isDialogLoading">
            <el-button @click="saveAlert(function() {skilldialog = false})">Close</el-button>
            <el-button type="primary" @click="saveAnswer()" :loading="saving">Save</el-button>
            <el-button type="success" v-if="nextPage != ''" @click="showNextPage(currentSkill,nextPage.page, nextPage.id )">Next</el-button>
            <!--<el-button type="warning" v-if="role == 'teacher'" :disabled="confirmAllDisabled"  @click="confirmAll" :loading="isConfirmAllLoading">Confirm all and sign</el-button>-->
        </div>

        <!--点关闭/next弹窗-->
        <el-dialog title="是否保存当前修改" :visible.sync="leaveDialog">
            <span>如果不保存，您更改的内容将会丢失。<br/>Changes you made may not be saved.<br/></span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="leaveDialog = false">Cancel</el-button>
                <el-button :plain="true" type="danger" @click="unSaveAction">Don't save</el-button>
                <el-button type="primary" :loading="saving" @click="saveAction">Save</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import Cookies from 'js-cookie'
    import axios from 'axios'    
    import Sortable from 'sortablejs'
    export default {
        name: 'reportDialog',
        //props去掉report属性，防止因vue父子组件响应式更新而造成cope和aope存储答案时串掉
        props: ['isLineRead','notificationId'],
        data() {
            return {
                report:{},
                studentId: 0,
                userId: 0,
                role: '',
                displayName: '',
                skilldialog: false,
                questions: [],
                oldQuestions: [],
                hasOldQuestions: false,
                comments: [],
                showCommentCount: 3,
                forTeacher: [],
                currentSkill: {},
                currentPage: '',
                currentPageId: 0,
                nextPage: {},
                saving: false,
                isDirty:false,
                maxLength:4000,
                isDialogLoading:false,
                confirmAllDisabled : false,
                currentSaving:'',
                datepickerOptions: {
                    option1: {

                    }
                },
                //plan做完后面两个page才可以做
                disabledTips:'',
                pageLock: true,//是否显示lock按钮
                lock: true,//switch的状态
                //close／next弹窗
                leaveDialog:false,
                from:'',//判断点了close还是next
                skill:'',
                page:'',
                pageId:0,
                isConfirmAllLoading:false,
                sortable: null,
                teacherEditEnabled: true,
                studentEditEnabled: true
            }
        },
        methods: {
            //行拖拽
            rowDrop() {
                var indexList = []
                this.questions.forEach((questionGroup,i) => {
                    questionGroup.forEach(question => {
                        if(question.config.type == "table"){
                            indexList.push(i)
                            var el  = document.querySelector(`.drag${i} .el-table__body-wrapper tbody`)
                            const _this = this
                            Sortable.create(el, {
                                onEnd: evt => {
                                    //操作数据
                                    _this.$nextTick(()=>{
                                        const targetRow = question.config.list.splice(evt.oldIndex, 1)[0]
                                        console.log(targetRow,"jjjj")
                                        question.config.list.splice(evt.newIndex, 0, targetRow)
                                        })
                                        console.log(question.config.list,"调整后")
                            
                                }
                            })
                        }

                    })
                })
            },
            //POST键盘事件
            pressAction:function(question,commentList,ev){
                if (13 == ev.keyCode && ev.ctrlKey) { //ctrl + enter
                    if (question.content && !question.isSavingComment) { // 有输入值且没有正在保存。因为是代码触发，所以必须加上这个判断
                        this.saveComment(question, commentList)
                    }
                }
            },

            //此方法在复制对象时会将数组clone成对象，但为了兼容之前点击‘+’产生的数据，所以仍然采用此方法
            clone: function (myObj) {
                if (typeof(myObj) != 'object') return myObj;
                if (myObj == null) return myObj;
                var myNewObj = new Object();
                for (var i in myObj)
                    myNewObj[i] = this.clone(myObj[i]);
                return myNewObj;
            },
            saveAlert: function (done) {
                if(this.isDirty){
                    this.leaveDialog = true;
                    this.from = 'close'
                }else{
                    this.isDirty = false;
                    done();
                }
            },

            //close和next公用弹窗，三种操作执行时需先判断用户是点击了close还是leave
            unSaveAction(){
                this.leaveDialog = false;
                if(this.from === 'close'){
                    this.skilldialog = false;
                    this.isDirty = false;
                }else {
                    this.showPage(this.skill, this.page, this.pageId);//showpage函数里有重置isDirty为false，故此处不用
                }

            },
            saveAction(){
                this.saving = true;
                this.leaveDialog = false;
                this.saveAnswer();
                if(this.from === 'close'){
                    this.skilldialog = false;
                    this.isDirty = false;
                }else {
                    this.showPage(this.skill, this.page, this.pageId);
                }
            },

            getCurrentPageIndex: function (skill, page) {
                for (var i = 0; i < skill.pageList.length; i++) {
                    if (skill.pageList[i].page == page) return i;
                }
            },

            more: function (obj) {
                if(obj.length >= 50) {
                    this.$message.error('There can be 50 answers at most.');
                    return false;
                }
                var newObj = this.clone(obj[obj.length - 1]);
                newObj.id = obj.length + 1
                for( var config in newObj.list){
                    newObj.list[config].answer = '';
                }
                console.log(newObj,"")
                obj.push(newObj);
                this.isDirty = true;
            },
            less: function (obj) {
                this.$confirm('Confirm to delete the answer?', 'Warning', {
                    confirmButtonText: 'Delete',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    var msg = '';
                    var type = '';
                    if (obj.length > 1){
                        obj.pop();
                        msg = 'success';
                        type = 'success';
                    }else {
                        msg = 'You can\'t delete when there\'s only one answer.';
                        type = 'error';
                    }
                    this.$message({
                        type: type,
                        message: msg
                    });
                }).catch(() => {
                    // 用户点了取消删除
                    this.$message.error(error.message);
                });
                this.isDirty = true;
            },

            showNextPage :function (skill, page, pageId) {
                if(this.isDirty){
                    this.leaveDialog = true;
                    this.from = 'next';
                    this.skill = skill;
                    this.page = page
                    this.pageId = pageId;
                }else{
                    this.showPage(skill, page, pageId);
                }
            },

            //获取指定page的问题，当前page没有回答时请求加载
            getQuestion: function (pageId, params) {
                this.$http.get('question/' + pageId).then(response =>{
                    this.hasOldQuestions = false;
                    this.handleQuestionList(response.questionList, params);
                }).catch(error =>{
                    this.$message.error(error);
                });
            },

            //请求当前page答案
            getAnswer: function (pageId, params) {
                this.$http.get('report/answer?reportId=' + this.report.id + '&pageId=' + pageId).then(response =>{
                    if (response.questionList.length == 0) {
                        this.getQuestion(pageId, params);
                    } else {
                        this.hasOldQuestions = true;
                        this.handleQuestionList(response.questionList, params);
                    }
                }).catch(error =>{
                    throw Error(error)
                    //this.$message.error(error);
                });
            },


            //通过此函数获得请求并显示dialog所需的所有数据
            getDialogAll: function (pageId, params) {
                //请求当前page评论
                this.$http.get('comment/page?studentId=' + this.studentId + '&pageId=' + pageId).then(response => {
                    this.comments = response;
                    this.getAnswer(pageId, params)
                }).catch(error => {
                    this.$message.error(error.message);
                });
            },

            closeDialog: function () {
                this.isDirty = false;
                window.onbeforeunload = null;
                window.onunload = null;
                if(!this.isLineRead){
                    this.$emit('close',{id:this.notificationId})
                }
            },

            //处理显示当前page的所有逻辑
            showPage: function (skill, page, pageId, params) {
                if (page === '' || page == undefined) return;
                this.reset()

                this.currentSkill = skill;
                this.currentPage = page;
                this.currentPageId = pageId;
                //清空this.questions,
                this.questions.splice(0, this.questions.length);
                this.getDialogAll(pageId, params);
                this.progressActiveIndex = this.getCurrentPageIndex(skill, page);
                this.isDialogLoading = true;
                this.skilldialog = true;
                for (var i = 0; i < skill.pageList.length; i++) {
                    var pageObj = skill.pageList[i];
                    if (pageObj.page == page) {
                        if (i == (skill.pageList.length - 1)) {
                            this.nextPage = '';
                        } else {
                            this.nextPage = {page: skill.pageList[i + 1].page, id: skill.pageList[i + 1].id};
                        }
                    }
                }

                window.onbeforeunload = function(){
                    return "你的表单有些修改尚未保存，是否确定要离开?\nSome changes aren\'t saved. Are you sure leaving the page?";
                }

                window.onunload = function () {
                    return "你的表单有些修改尚未保存，是否确定要离开?\nSome changes aren\'t saved. Are you sure leaving the page?";
                }

                this.getLock(this.report.id, pageId)

            },

            showDialogFromTeacher: function (report, skill, page, pageId, student) {
                this.report = report;
                this.studentId = student.id;
                this.displayName = student.displayName;
                this.showPage(skill, page, pageId);
            },

            showDialogFromStu: function (report ,skill, page, pageId, studentName) {
                this.report = report;
                this.displayName = studentName;
                this.showPage(skill, page, pageId);
            },

            showDialogFromNoti: function (report, skill, page, param) {
                //if(this.role !== 'student'){
                this.report = report;
                this.studentId = param.studentId;
                this.displayName = param.studentName;
                //}
                this.showPage(skill, page.page, page.id,param);
            },

            reset() {
                this.saving = false;
                this.isDirty = false;
                this.hasOldQuestions = false;
                this.isDialogLoading = false;
                this.confirmAllDisabled = false;
                this.currentSaving = '';
            },
            //提交评论
            saveComment: function (question, commentList) {
                question.isSavingComment = true;
                this.$http.post('comment', {studentId: this.studentId, questionId: question.id, content: question.content}).then(response => {
                    commentList.push(response);
                    this.$message({message: 'Your comment is successfully posted.', type: 'success'});
                    question.content = '';
                    question.isSavingComment = false;

                }).catch(error => {
                    this.$message.error(error.message);
                    question.isSavingComment = false;
                })
            },

            //删除评论
            cancelComment: function (comment, commentList) {
                this.$http.delete('comment/'+ comment.id).then(response => {
                    commentList.splice(commentList.indexOf(comment),1)
                    this.$message.success('Comment removed')
                }).catch(error => {
                    this.$message.error(error.message)
                })
            },

            setHighlight(list, id, successFn) {
                (list || []).forEach(items => {
                    items.forEach(item => {
                        if (item.id === id) {
                            successFn instanceof Function && successFn(item);
                        }
                    })
                })
            },

            checkQuestionInput: function (value) {
                this.isDirty = true;
                this.checkEmoji(value);
            },

            checkEmoji: function (value) {
                let regStr = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/ig;
                if(regStr.test(value)) this.$message.warning('Emoji is not supported, please remove it from your answer or comment.');
            },

            //将数据渲染到模态框中
            handleQuestionList: function (list, params) {
                //清空this.questions,
                this.questions.splice(0, this.questions.length);
                let count = 0;
                console.log(list,"list")
                for (var i = 0; i < list.length; i++) {//list
                    var group = [];
                    for (var j = 0; j < list[i].length; j++) {//list内层循环
                        list[i][j].show = false;
                        list[i][j].highlighted = false;
                        //绑定comment
                        list[i][j].content = '';
                        list[i][j].isSavingComment = false;
                        list[i][j].showCommentCount = this.showCommentCount;
                        list[i][j].commentList = this.comments[count];
                        list[i][j].config = JSON.parse(list[i][j].config);
                        list[i][j].highlighted = false;
                        for(var x =0; x<list[i][j].config.list.length ; x++){//config.list循环
                            // if(list[i][j].config.type == "table"){
                            //     list[i][j].config.list[x] = {
                            //         list:list[i][j].config.list[x],
                            //         id:x + 1
                            //     }
                            // }
                            // 否则list[x]是数组，进行遍历操作
                            for(var y=0; y< list[i][j].config.list[x].length; y++){
                                let item = list[i][j].config.list[x][y];
                                if (item.type === 'datetime') {
                                    if(item.date !== '' || item.time !== ''){
                                        list[i][j].canBeConfirm = true
                                    }
                                } else {
                                    if(item.answer !== '') list[i][j].canBeConfirm = true;
                                }
                            }
                        }
                        group.push(list[i][j]);
                        count++;
                    }
                    this.questions.push(group);
                }
                this.refreshOldQuestions();
                // 单独处理一下拖拽所需要用的数据格式
                this.$nextTick(() => {
                    this.questions.forEach((questionGroup) => {
                        questionGroup.forEach(question => {
                            if(question.config.type == "table"){
                                question.config.list = question.config.list.map((item,index) =>{
                                    return {list:item,id:index +1}
                                })
                            }
                        })
                    })
                    this.rowDrop()
                })
                if(params !== undefined  && params !== null){
                    if (params.type === 'answer') {
                        let questionId = params.questionId;
                        this.setHighlight(this.questions, questionId, item => {
                            item.highlighted = true;
                        })
                    }
                    if (params.type === 'comment') {
                        let commentId = params.commentId;
                        this.setHighlight(this.comments, commentId, item => {
                            item.highlighted = true;
                        })
                        // 遍历questions，判断当前评论所在位置，如果所在位置小于评论长度-3，表明当前评论被hide，需要将其展开，否则不做处理
                        // forEach() => 数组源生方法，用于遍历数组项
                        this.questions.forEach(qs => {
                            // qs => question部分
                            qs.forEach(q => {
                                // q => 每一个question
                                q.commentList.forEach((c, i) => {
                                    // c => 每一个question的comment
                                    if (c.id === commentId && i < q.commentList.length - 3) {
                                        q.showCommentCount = q.commentList.length;
                                    }
                                })
                            })
                        })
                    }
                }
                this.isDialogLoading = false
                //因为element在给date组件赋值的之后已经触发了其change事件，进而isdirty被置为true，因此，此段代码让页面在加载完成数据之后将其置为false
                setTimeout(() => {
                    this.isDirty = false;
                    // 跳转到指定元素前
                    if (params) {
                        if (params.type === 'comment') {
                            let commentDom = document.getElementById('comment'+ params.commentId);
                            commentDom && commentDom.scrollIntoView();
                        } else if (params.type === 'answer') {
                            let answerDom = document.getElementById('question'+ params.questionId);
                            answerDom && answerDom.scrollIntoView();
                        }
                    }
                }, 0);
            },

            refreshOldQuestions: function () {
                if(this.hasOldQuestions){
                    this.oldQuestions = []
                    this.questions.forEach(group =>{
                        let oldGroup = [];
                        group.forEach(question =>{
                            let list = [];
                            for(let i=0; i<question.config.list.length;i++){
                                if(question.config.list[i] instanceof Array){
                                    let temp = [];
                                    for(let j=0; j<question.config.list[i].length;j++){

                                        //此处将对象序列化后在反序列化的目的是深拷贝对象，没有使用methods中的clone方法是因为
                                        //element日期控件中的值发生变化时，如果使用clone方法复制对象会造成日期控件的值变成一个空的object
                                        temp.push(JSON.parse(JSON.stringify(question.config.list[i][j])));
                                    }
                                    list.push(temp);
                                }else{
                                    list.push(JSON.parse(JSON.stringify(question.config.list[i])))
                                }

                            }
                            let oldQuestion= {config:{list: list}}
                            oldGroup.push(oldQuestion);
                        });
                        this.oldQuestions.push(oldGroup)
                    })
                }
            },

            // 设置当前页状态为对勾
            setPageConfirmed(isConfirmed) {
                for(var i =0; i<this.currentSkill.pageList.length; i++){
                    if(this.currentSkill.pageList[i].page === this.currentPage){
                        this.currentSkill.pageList[i].confirmed = isConfirmed;
                    }
                }
            },

            // 根据signature和date值，设置confirmed的状态，并返回当前question
            setConfirmedForSignatureAndDate(question) {
                question.confirmed = question.config.list[0][0].answer !== '';
                return question;
            },

            // 保存之前确保日期双向绑定的值不为undefined，以防日期不能选
            handleDateAnswer (item = {}, type) {
                if (type === 'date' || type === 'tableDate') {
                    if (item.answer === undefined) {
                        item.answer = ''
                    }
                }
                // 根据type，格式化answer数据
                if (type === 'datetime') {
                    if (item.time === undefined) {
                        item.time = ''
                    }
                    if (item.date === undefined) {
                        item.date = ''
                    }
                }
                return item;
            },

            saveAnswer () {
                console.log(this.role)
                console.log(this.teacherEditEnabled)
                console.log(this.studentEditEnabled)
                if ((this.role === 'student' && !this.studentEditEnabled) || (this.role === 'teacher') && !this.teacherEditEnabled) {
                  this.$message.error("You can't edit now!")
                  return;
                }
                if(!this.isDirty) {
                    this.$message({
                        type:'warning',
                        message:'Portfolio hasn\'t been edited'
                    });
                    this.saving = false;
                    return;
                }
                this.saving = true;
                this.saveButtonDisabled = true;
                let postQuestionList = [];

                // 获取问题组的数组长度
                let groupLen = this.questions.length;
                this.questions.forEach((group) => {
                    group.forEach(que => {
                        if(que.config.type == "table"){
                            que.config.list = que.config.list.map(item =>{
                                return item.list
                            })
                        }
                    })
                })
                this.questions.forEach((group, groupIndex) => {
                    group.forEach((question, questionIndex) => {
                        // 判断当遍历到最后一组（签名&日期组）时，调用方法设置其confirmed状态
                        if (groupIndex === groupLen - 1) {
                            // this.setConfirmedForSignatureAndDate(question)
                        }
                        // 保存answer之前，判断是否还存在未被confirmed的question，如果存在启用confirm all 按钮，否则什么也不做。
                        if (!question.confirmed) {
                            this.confirmAllDisabled = false;
                        }
                        if(this.isQuestionDirty(question, groupIndex, questionIndex)){
                            let dateConfig = JSON.stringify(question.config)
                            dateConfig = JSON.parse(dateConfig)

                            dateConfig.list = dateConfig.list.map((itemGroup, itemGroupIndex) => {
                                // 判断是否是数组
                                console.log(itemGroup.constructor,"constructor")
                                if (itemGroup.constructor === Array) {
                                    // 遍历itemGroup
                                    return itemGroup.map(item => {
                                        let type = item.type
                                        return this.handleDateAnswer(item, type)
                                    })
                                } else {
                                        // itemGroup 不是数组，那么应该是使用more方法添加的对象，使用for in 循环遍历，其余同上
                                        for(let key in itemGroup) {
                                            let type = itemGroup[key].type
                                            itemGroup[key] = this.handleDateAnswer(itemGroup[key], type)
                                        }
                                        return itemGroup
                                }
                            })
                            dateConfig = JSON.stringify(dateConfig)

                            let answer = {
                                id: question.answerId,
                                reportId: this.report.id,
                                questionId: question.id,
                                answer: dateConfig,
                                confirmed: question.confirmed,
                                initialEmpty: question.initialEmpty
                            }
                            postQuestionList.push(answer);
                        }
                    });
                });

                if(postQuestionList.length === 0) {
                    this.saving = false;
                    this.$message.warning('Portfolio hasn\'t been edited, nothing saved.');
                    return;
                }

                let timestamp = new Date().getTime()+'';
                this.currentSaving = timestamp;
                axios.instance()({method:'post',url:'report/answer',data:postQuestionList,headers:{'requestId':timestamp}}).then(response => {
                    console.log(response)
                    if (response.data.c == 1) {
                      this.$message.error(response.data.i);
                      this.saving = false;
                      return;
                    }
                    if(response.data.id !== this.currentSaving) return;
                    var count = 0;
                    if(!this.hasOldQuestions){
                        for (var i = 0; i < this.questions.length; i++) {
                            var group = this.questions[i];
                            for (var j = 0; j < group.length; j++) {
                                group[j].answerId = response[count];
                                count++;
                            }
                        }
                    }
                    this.$message({message: 'Portfolio saved successfully.', type: 'success'});
                    // this.skilldialog = false;
                    this.saveButtonDisabled = false;

                    // 如果都已经confirmed，将页面状态更改为对勾
                    let isConfirmed = true;
                    this.questions.forEach(questionGroup=>{
                        if(isConfirmed){
                            isConfirmed = questionGroup.every(answer => {
                                return answer.confirmed;
                            });
                        }
                    })
                    this.setPageConfirmed(isConfirmed);

                    let list = this.questions;
                    for (var i = 0; i < list.length; i++) {
                        for (var j = 0; j < list[i].length; j++) {
                            for (var x = 0; x < list[i][j].config.list.length; x++) {
                                for (var y = 0; y < list[i][j].config.list[x].length; y++) {
                                    let q = list[i][j].config.list[x][y];
                                    if (q.type === 'datetime') {
                                        if (q.date !== '' || q.time !== '') {
                                            list[i][j].canBeConfirm = true;
                                        }
                                    } else {
                                        if (q.answer !== '') list[i][j].canBeConfirm = true;
                                    }

                                }
                            }
                        }
                    }
                    this.hasOldQuestions = true;
                    this.refreshOldQuestions();
                    this.$nextTick(() => {
                    this.questions.forEach((questionGroup) => {
                        questionGroup.forEach(question => {
                            if(question.config.type == "table"){
                                question.config.list = question.config.list.map((item,index) =>{
                                    return {list:item,id:index +1}
                                })
                            }
                        })
                    })
                    this.rowDrop()
                })
                    this.saving = false;
                    this.isDirty = false;
                }).catch(error => {
                    this.saving = false;
                    this.$message.error(error.message)
                })
            },

            isQuestionDirty: function (question, groupIndex, questionIndex) {
                if(!this.hasOldQuestions) {
                    console.log("走到这里了吗")
                    for(let i=0; i< question.config.list.length; i++) {
                        let row = question.config.list[i];
                        for(let index in row){
                            let col = row[index];
                            let type = col.type;
                            if(type === 'input' || type === 'tableInput' || type === 'radio' ||
                                type === 'date'  || type === 'tableDate') {
                                if (question.initialEmpty === undefined || question.initialEmpty) {
                                    question.initialEmpty = col.answer === '';
                                }
                            }

                            if(type === 'datetime') {
                                if (question.initialEmpty === undefined || question.initialEmpty) question.initialEmpty = col.date === '' && col.time === '';
                            }

                            if(type === 'checkbox') {
                                if (question.initialEmpty === undefined || question.initialEmpty) question.initialEmpty = col.answer === '' || col.answer.length === 0;
                            }
                        }

                    }
                    if (question.config.type === 'text') {
                        question.initialEmpty = true;
                    }
                    return true;
                }
                question.initialEmpty = false;
                let oldQuestion = this.oldQuestions[groupIndex][questionIndex];
                console.log(oldQuestion,"olddd")
                if(oldQuestion.config.list.length !== question.config.list.length) return true;
                for(let i=0; i< question.config.list.length; i++){
                    let row = question.config.list[i];
                    let oldRow = oldQuestion.config.list[i];
                    for(let index in row){
                        let oldCol = oldRow[index];
                        let col = row[index];
                        let type = col.type;
                        if(type === 'input' || type === 'tableInput' || type === 'text' || type === 'radio'){
                            if(col.answer !== oldCol.answer) return true;
                        }

                        if(type === 'date'  || type === 'tableDate'){
                            let oldDate = oldCol.answer === ''?'': Date.parse(new Date(oldCol.answer));
                            let date = col.answer === '' ? '':Date.parse(new Date(col.answer));
                            if(oldDate !== date) return true;
                        }

                        if(type === 'datetime'){
                            let oldDate = oldCol.date === ''?'': Date.parse(new Date(oldCol.date));
                            let date = col.date === '' ? '':Date.parse(new Date(col.date));
                            let oldTime = oldCol.time === ''?'': Date.parse(new Date(oldCol.time));
                            let time = col.time ===''?'': Date.parse(new Date(col.time));
                            if(date !== oldDate || time !== oldTime){
                                return true;
                            }
                        }
                        if(type === 'checkbox'){
                            let count = 0;
                            let answerBoxes = [];
                            for(let boxIndex in oldCol.answer){
                                answerBoxes.push(oldCol.answer[boxIndex]);
                                count++;
                            }
                            if(col.answer.length !== count) return true;
                            for(let x =0; x< col.answer.length; x++){
                                if(col.answer[x] !== answerBoxes[x]) return true;
                            }
                        }
                    }
                }
                return false;
            },


            confirm(question){
                this.$set(question,'isConfirmLoading', true);
                this.$http.patch('report/confirm/'+ question.answerId).then(response => {
                    //渲染数据
                    question.confirmed = true;
                    this.$message.success('Confirm success');
                    this.$set(question,'isConfirmLoading', false)
                    let unConfirm = 0;
                    this.questions.forEach(questionGroup =>{
                        questionGroup.forEach(question =>{
                            if(!question.config.forTeacher){
                                if(!question.confirmed) unConfirm++;
                            }
                        })
                    });

                    if(unConfirm === 0){
                        this.currentSkill.pageList.forEach((page, index) =>{
                            if(page.page === this.currentPage) page.confirmed = true;
                        })
                        //如果第一页所有问题都被confirmed，则改变后几页的状态
                        if (this.currentSkill.pageList[0].id === this.currentPageId){
                            this.switchLock()
                        }
                    }
                }).catch(error => {
                    this.$message.error(error.message);
                    this.$set(question,'isConfirmLoading', false)

                })
            },

            disapprove: function (question) {
                this.$set(question,'isDisapproveLoading', true);
                this.$http.patch('report/disapprove/'+ question.answerId).then(response => {
                    this.$message.success('Disapprove success');
                    question.confirmed = false;
                    this.$set(question,'isDisapproveLoading', false);
                    for(var i =0; i<this.currentSkill.pageList.length; i++){
                        if(this.currentSkill.pageList[i].page === this.currentPage){
                            this.currentSkill.pageList[i].confirmed = false;
                        }
                    }
                }).catch(error=> {
                    this.$message.error(error.message);
                    this.$set(question,'isDisapproveLoading', false);
                })
            },

            confirmAll(){
                if(this.isDirty){
                    this.$message.warning('You must save the answers before confirming all questions.');
                    return;
                }
                this.isConfirmAllLoading = true;
                let list = this.questions;
                for (let i = 0; i < list.length; i++) {
                    if(i === (list.length-1)) break;
                    for (let j = 0; j < list[i].length; j++) {
                        let questionFlag = false;
                        for (let x = 0; x < list[i][j].config.list.length; x++) {
                            for (let y = 0; y < list[i][j].config.list[x].length; y++) {
                                let q = list[i][j].config.list[x][y];
                                if (q.type === 'datetime') {
                                    if (q.date !== '' || q.time !== '') {
                                        questionFlag = true;
                                    }
                                } else {
                                    if (q.answer !== '') questionFlag = true;
                                }

                            }
                            if(!questionFlag){
                                this.$message.error('Some questions aren\'t filled with answer');
                                this.isConfirmAllLoading = false;
                                return;
                            }
                        }
                    }
                }
                this.$http.patch('report/confirm',{},{params:{reportId:this.report.id, pageId:this.currentPageId}}).then(response => {
                    let isPageConfirmed = true;
                    list[list.length - 1][0].config.list[0][0].answer = response.name;
                    list.forEach((questionGroup, questionGroupIndex) => {
                        // questionGroup => 问题组
                        questionGroup.forEach((question, questionIndex) => {
                            if(questionGroupIndex === list.length-1){
                                // this.setConfirmedForSignatureAndDate(question);
                                if(isPageConfirmed) isPageConfirmed = question.confirmed
                            }else{
                                // 将所有question的confirm都设为true
                                question.confirmed = true;
                            }
                        })
                    });
                    // 封装方法，confirm all and sign后，将页面状态设为对勾
                    this.setPageConfirmed(isPageConfirmed);
                    this.isConfirmAllLoading = false;
                    this.$message.success('Confirm all and sign success');

                    //如果第一页all confirmed，则改变后几页的状态
                    if (this.currentSkill.pageList[0].id === this.currentPageId){
                        this.switchLock()
                    }

                }).catch(error => {
                    this.isConfirmAllLoading = false;
                    this.$message.error(error.message);
                })
            },

//            改变lock状态
            switchLock(lock){
                let otherPageID = []//手动改变某page的状态时同步改变其他page的lock状态
                this.currentSkill.pageList.forEach((page, index) =>{
                    if(index !==0 ){
                        otherPageID.push(this.currentSkill.pageList[index].id)
                    }
                })
                var parms = {
                    reportId: this.report.id,
                    pageList: otherPageID,
                    lock: !!lock
                }
                this.$http.post('report/lockSwitch/', parms).then(response => {
                    this.getLock(this.report.id, this.currentPageId);
                }).catch(error=> {
                    this.$message.error(error.message);
                })
            },

//            获取lock状态
            getLock(reportId, pageId){
                this.$http.get('report/lockStatus?reportId=' + reportId + '&pageId=' + pageId).then(response => {
                    this.pageLock = response.pageLock
                    this.lock = response.lock
                    this.disabledTips= response.lock?'Cannot be editable until all the questions under ' + this.currentSkill.pageList[0].page+' part are confirmed':''
                }).catch(error=> {
                    this.$message.error(error.message);
                })
            },

            getEditEnabled() {
              this.$http.get('/common/edit/enabled').then(response => {
                console.log(response)
                this.teacherEditEnabled = response['TEACHER']
                this.studentEditEnabled = response['STUDENT']
              }).catch(error=> {
                this.$message.error(error.message);
              })
            },


            init: function () {
                this.role = Cookies.get('role');
                this.userId = Cookies.get('userid');
                this.displayName = decodeURI(Cookies.get('name'));
                if (this.role === 'student') {
                    this.studentId = Cookies.get('studentId');
                }
                if(this.role === 'teacher') {
                    this.teacherId = Cookies.get('teacherId');
                }
                this.getEditEnabled()
            }
        },
        mounted: function () {
            this.$nextTick(function () {
                this.init();
                document.body.ondrop = function (event) {
                event.preventDefault();
                event.stopPropagation();
            };
            })
            
        },
    };
</script>

<style lang="scss" scoped>

    @import "../../css/variable";

    .radius-10 {
        border-radius: 10px;
    }

    .content {
        .border-b {
            border-bottom: 1px solid $header-color;
        }
        .skillListTitle {
            height: 36px;
            background: $header-color;
            border-top-left-radius: 8px;
            border-top-right-radius: 8px;
            h2 {
                display: block;
                float: left;
            }
            button {
                float: right;
            }
        }
        .line-right {
            button {
                display: inline-flex;
                width: 100%;
            }
        }
    }

    @-moz-document url-prefix() {
        .line-right button {
            text-align: left; //火狐下button文字居中对齐改为居左
        }
    }

    .inlineBlock {
        display: inline-block;
    }

    .owner {
        position: absolute;
        top: -68px;
        right: 40px;
    }

    .fixedFooter{
        z-index: 20005;
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 60px;
        line-height: 60px;
        text-align: center;
        background: $white;
        box-shadow: 0 0 10px rgba(0,0,0,.3);
    }
    .commentContent{
        white-space: pre;
        word-wrap: break-word;
        -ms-word-wrap: break-word;
        -ms-word-wrap: break-word;

        white-space: pre-wrap;/* css-3*/
        white-space: -moz-pre-wrap;  /*Mozilla, since 1999*/
        white-space: -o-pre-wrap; /* Opera 7*/
        word-wrap: break-word; /*Internet Explorer 5.5+*/
    }
    .el-checkbox, .el-checkbox__input {
    vertical-align:top;
        display: inline-block;
    }

</style>



// WEBPACK FOOTER //
// ReportDialog.vue?78f691f2